import axios               from "axios";
import { configs as API }  from "_config/index";
import Cookies             from "js-cookie";
import { getSHA256String } from "_common/utils/user";
import { PAYTM_MINI_APP }  from "_config/index";

export function checkForPaytmMiniApp () {
	let bool = false;

	if ( Cookies ) {
		let cookieData = Cookies.get ( "external_env" );

		bool = !!( cookieData && cookieData === PAYTM_MINI_APP );
	}
	if ( !bool && process.browser ) {
		const ua = window.navigator.userAgent;

		bool = /AppContainer/i.test ( ua );
	}

	return bool;
}

export const getPaytmMiniAppAccessToken = async props => {
	await ready ( () => readyCallback ( props ) );
};

export const openInBrowser = props => {
	const requestObject = { url: props.url };
	const JSBridge      = window?.JSBridge;

	ready ( () => JSBridge.call ( "openInBrowser", requestObject ) );
};

async function readyCallback ( params ) {
	const { executeAuthActions, dispatch } = params;

	return new Promise ( ( resolve, reject ) => {
		const JSBridge = window?.JSBridge;

		JSBridge.call ( "paytmFetchAuthCode", { clientId: "merchant-rooter-prod" }, async function ( result ) {
			if ( result && result.data ) {
				await executeAuthActions ( { dispatch, tokenData: result.data } );

				return resolve ( "yes" );
			} else {
				return reject ( "no" );
			}
		} );
	} );
}

async function ready ( callback ) {
	// call if jsbridge is injected
	if ( window.JSBridge ) {
		try {
			await callback ();
		} catch ( error ) {
			return;
		}
	} else {
		// listen to jsbridge ready event
		document.addEventListener ( "JSBridgeReady", callback, false );
	}
}

export const getPaytmMiniAppUserData = async token => {
	try {
		const body      = { ...token, deviceType: "web", pushId: "webPushId", locale: "en" };
		const authToken = await getSHA256String ( [ JSON.stringify ( body ) ] );
		const result    = await axios ( {
			url     : `${ API.USER_API_URL }paytm/miniApp`,
			method  : "POST",
			headers : {
				authorization: authToken
			},
			data: body
		} );

		return result.data;
	} catch ( error ) {
		return;
	}
};
